<template>
  <div
    style="
      width: 126px;
      position: relative;
      border: solid 1px #435373;
      padding: 6px 2px 2px 2px;
      background-color: rgba(136, 182, 243, 0.15);
      border-top-right-radius: 28px;
    "
  >
    <!-- 病害指数 -->
    <item-figure :val="profile.val" :name="profile.name"></item-figure>
    <!-- 图片 -->
    <div style="overflow: hidden; margin-top: 8px; height: 200px">
      <img
        :src="picture"
        style="
          margin-left: -80px;
          -moz-opacity: 0.5;
          opacity: 0.4;
          height: 200px;
        "
      />
    </div>
    <!-- 病害描述 -->
    <div
      style="
        color: #cfe3ef;
        font-size: 12px;
        height: 100px;
        position: absolute;
        top: 80px;
        display: none;
      "
    >
      {{ profile.desc }}
    </div>
  </div>
</template>
<script>
import ItemFigure from './item-figure.vue'
export default {
  components: { ItemFigure },
  props: ['profile'],
  computed: {
    picture() {
      const { picture } = this.profile
      return `http://picture.zkhfzhnyg.cn/digiberry/feature/${
        picture || '_blank.png'
      }`
    },
  },
}
</script>


// WEBPACK FOOTER //
// src/components/screen28896/disease-zone/item.vue